import React, { Suspense } from 'react';
import AccordionTitle from './accordionTitle'
import { ContractConstants, LocationIds, OfferTypes } from './../../constants/actionType';
import { parentAccordionFocusAnimate, focusAnimation, updateContractStatus, updateContract } from './../../action/buildProduct';
import { InHomeUtils } from './../../util/inhomeUtils';
import {catchJSException} from './../../service/logService';
import ReactHtmlParser from 'react-html-parser';
const LazyImage = React.lazy(() => import("../../components/lazyImage"));
const images = {
  visaCard300: require("./../../assets/ak-cached/24h/img/accV2/300visacard.png")
    .default,
  visaCard200: require("./../../assets/ak-cached/24h/img/accV2/200visacard.png")
    .default,
  visaCardNew:
    require("./../../assets/ak-cached/24h/img/accV2/visacard_new.png").default,
};

class contractAccordion extends React.PureComponent {
    constructor(props) {
        super(props);
    this.contractAccordionRef = React.createRef();
    }
    handleKeyDown = (e, contract) => {
        //keyboard accessibility for accordion using space bar and enter keys
        if (e.keyCode === 13 || e.keyCode === 32) {
          this.updateContract(contract);
        }
      }
    componentDidUpdate () {
        if (this.props.buildProduct.focusParentAccordion && this.props.buildProduct.contract.isAccordionOpenRequired && this.props.buildProduct.contract.isAccordionOpen) {
        if (this.contractAccordionRef) {
            parentAccordionFocusAnimate(this.props.dispatch);
            focusAnimation(this.contractAccordionRef.offsetTop - 10);
            }
        }
    }
    updateContract = ((contract) => {
        try{
            if (this.props.buildProduct.contract.contractType !== contract) {
            	let contractState = this.props.buildProduct.contract;
                let tvSelectionProdId = "";
                contractState.isContractSwitched = true;
                contractState.contractType = contract;
                updateContractStatus(contractState, this.props.dispatch);
                if (InHomeUtils.isNotNull(this.props.buildProduct.tv) && InHomeUtils.isNotNull(this.props.buildProduct.tv.selectedProduct) && this.props.buildProduct.tv.selectedProduct.id !== '')
                    tvSelectionProdId = this.props.buildProduct.tv.selectedProduct.id;
                updateContract(this.props.visitId, contract, this.props.dispatch, this.props.lqState.selectedState.zip, this.props.lqState.lqResponse.tarCode, this.props.buildProduct.selectedCoreServices, this.props.buildProduct.masterpackageview, tvSelectionProdId, this.props.lqState.servicesQualified,this.props.flowType);
            }
        }
        catch(ex)
        {
            catchJSException('BuildProduct',this.props.appState.visitId,'contractAccordion-updateContract',ex);
        }        
    });

    getVisaOfferImage = ((offerText, visaImage) => {
        if(InHomeUtils.isNotNull(offerText) && offerText !== undefined && InHomeUtils.isNotEmpty(offerText) )
        {
        if ( offerText.indexOf("$300 Visa") > -1) {
            visaImage = <Suspense fallback={<div>loading...</div>}><LazyImage className="p-50" alt="Visa prepaid card" src={images.visaCard300} /></Suspense>;
        }
        else if (offerText.indexOf("$250 Visa") > -1) {
            visaImage = <Suspense fallback={<div>loading...</div>}><LazyImage className="p-50" alt="Visa prepaid card" src={images.visaCard300} /></Suspense>;
        }
        else if (offerText.indexOf("$200 Visa") > -1) {
            visaImage = <Suspense fallback={<div>loading...</div>}><LazyImage className="p-50" alt="Visa prepaid card" src={images.visaCard200} /></Suspense>;
        }
        else if (offerText.indexOf("$100 Visa") > -1) {
            visaImage = <Suspense fallback={<div>loading...</div>}><LazyImage className="p-50" alt="Visa prepaid card" src={images.visaCardNew} /></Suspense>;
        }
    }
        return visaImage;
        
    });

    getOfferText = ((offerObj, seperator) => {
        let returnObj = [];
        if(InHomeUtils.isNotNull(offerObj) && offerObj.length > 0) {
            returnObj = offerObj.map((promo, index) => {
                if (index < offerObj.length - 1 && InHomeUtils.isNotEmpty(seperator)) {
                    return (promo?.OfferText + seperator + " ")
            }
            else {
                    return (promo?.OfferText);
                }
            })
        }
        return returnObj;
    });
    render() {
      //  let isGPONIONTEligible = this.props.buildProduct.isGPONIONTEligible;
        let isAccordionDisabled = (this.props.buildProduct.contract.isAccordionDisabled && !this.props.buildProduct.contract.isAccordionOpenRequired);
        let accordionTitle = "Contract, or no ?";
        let contractSelection = '';
        //let ionteligible200 = '';
        //let ionteligible300 = '';
        let accordionImg = false;
        //let rewardOffer = "";        
        //let isRewardOffer = false;
        let visaOfferImg = '';
        let visaOfferImgMTM = '';
        let visaOfferImg2YR = '';
        let splOffer2YRWithGrubhub = false;
        let splOfferMTMWithGrubhub = false;

        let isCartData = (InHomeUtils.isNotNull(this.props.cart) && InHomeUtils.isNotNull(this.props.cart.cartData) && this.props.cart.cartData.length > 0) ? true : false;
        let offers2YR = InHomeUtils.isNotNull(this.props.buildProduct.contractoffer) && InHomeUtils.isNotNull(this.props.buildProduct.contractoffer.offerplans2YR) && this.props.buildProduct.contractoffer.offerplans2YR.length > 0 ? this.props.buildProduct.contractoffer.offerplans2YR : [];
        let offersMTM = InHomeUtils.isNotNull(this.props.buildProduct.contractoffer) && InHomeUtils.isNotNull(this.props.buildProduct.contractoffer.offerplansMTM) && this.props.buildProduct.contractoffer.offerplansMTM.length > 0 ? this.props.buildProduct.contractoffer.offerplansMTM : [];

        let specialOffers2YR = InHomeUtils.isNotNull(this.props.buildProduct.sploffer) && InHomeUtils.isNotNull(this.props.buildProduct.sploffer.offerplans2YR) && this.props.buildProduct.sploffer.offerplans2YR.length > 0 ? this.props.buildProduct.sploffer.offerplans2YR : [];
        let specialOffersMTM = InHomeUtils.isNotNull(this.props.buildProduct.sploffer) && InHomeUtils.isNotNull(this.props.buildProduct.sploffer.offerplansMTM) && this.props.buildProduct.sploffer.offerplansMTM.length > 0 ? this.props.buildProduct.sploffer.offerplansMTM : [];

        let flashoffers2YR = InHomeUtils.isNotNull(this.props.buildProduct.flashoffer) && InHomeUtils.isNotNull(this.props.buildProduct.flashoffer.offerplans2YR) && this.props.buildProduct.flashoffer.offerplans2YR.length > 0 ? this.props.buildProduct.flashoffer.offerplans2YR : [];
        let flashoffersMTM = InHomeUtils.isNotNull(this.props.buildProduct.flashoffer) && InHomeUtils.isNotNull(this.props.buildProduct.flashoffer.offerplansMTM) && this.props.buildProduct.flashoffer.offerplansMTM.length > 0 ? this.props.buildProduct.flashoffer.offerplansMTM : [];

        offers2YR = this.getOfferText(offers2YR, ',');
        offersMTM = this.getOfferText(offersMTM, ',');
        specialOffers2YR = this.getOfferText(specialOffers2YR, ' or');
        specialOffersMTM = this.getOfferText(specialOffersMTM, ' or');
        flashoffers2YR = this.getOfferText(flashoffers2YR, ' or');
        flashoffersMTM = this.getOfferText(flashoffersMTM, ' or');

        let  splOffers2YR = [offers2YR.join(''), specialOffers2YR.join(''), flashoffers2YR.join('')].filter(Boolean);
        let  splOffersMTM = [offersMTM.join(''), specialOffersMTM.join(''), flashoffersMTM.join('')].filter(Boolean);

        if(InHomeUtils.isNotNull(splOffers2YR) && splOffers2YR.length > 0) {
            splOffers2YR.forEach((promo, index) => {
                visaOfferImg2YR = this.getVisaOfferImage(promo, visaOfferImg2YR);
            })
        } 

        if(InHomeUtils.isNotNull(splOffersMTM) && splOffersMTM.length > 0) {
            splOffersMTM.forEach((promo, index) => {
                visaOfferImgMTM = this.getVisaOfferImage(promo, visaOfferImgMTM);
            })
        }

        splOffers2YR = splOffers2YR.join(', ');
        splOffersMTM = splOffersMTM.join(', ');
        
        let offerInCart = '';
        let offerContract = '';
        if (InHomeUtils.isNotNull(this.props.buildProduct.contractoffer) && InHomeUtils.isNotNull(this.props.buildProduct.contractoffer.offersInCart)) {
            offerContract = this.props.buildProduct.contractoffer.offerContract;
            offerInCart = this.getOfferText(this.props.buildProduct.contractoffer.offersInCart, '');
            offerInCart.forEach((promo, index) => {
                visaOfferImg = this.getVisaOfferImage(promo, visaOfferImg);
            })
            offerInCart = offerInCart.join(', ');
        }
        
        if (InHomeUtils.isNotNull(this.props.buildProduct.internet.selectedProduct) || InHomeUtils.isNotNull(this.props.buildProduct.tv.selectedProduct)  || InHomeUtils.isNotNull(this.props.buildProduct.voice.selectedProduct)) {
            if (this.props.buildProduct.contract.contractType === ContractConstants.twoYear) {
                accordionTitle = this.props.isHoaFlow ? ContractConstants.accordionMonthToMonthTitle : ContractConstants.accordionTwoYearTitle;
                accordionImg = true;
            }
            else {
                this.props.buildProduct.contract.contractType = ContractConstants.monthToMonth;
                accordionTitle = ContractConstants.accordionMonthToMonthTitle
                accordionImg = false;
            }
        }

        if(InHomeUtils.isNotEmpty(visaOfferImg)) {
            this.props.buildProduct.contract.contractType === ContractConstants.twoYear ? visaOfferImg2YR = visaOfferImg : visaOfferImgMTM = visaOfferImg;
        }
        if(isCartData){
            if(InHomeUtils.isNotNull(this.props.cart.cartData[0].Promotions) 
            && InHomeUtils.isNotNull(this.props.cart.cartData[0].Promotions.promotions) 
            && this.props.cart.cartData[0].Promotions.promotions.length > 0){
                let grubHubOffer = false;
                this.props.cart.cartData[0].Promotions.promotions.map((promoItem) => {
                    if(InHomeUtils.isNotNull(promoItem.offerAttr) && InHomeUtils.isNotNull(promoItem.offerAttrValue) &&   promoItem.offerAttr === OfferTypes.SpecialDiscount && promoItem.offerAttrValue === OfferTypes.Grubhub){
                        grubHubOffer = true;
                    }
                }); 
                if(!grubHubOffer) {
                    if(InHomeUtils.isNotNull(splOffers2YR) && splOffers2YR.length > 0 && splOffers2YR.indexOf("Grubhub") > -1) {
                        splOffers2YR = splOffers2YR.replace(", Fios Grubhub Reward","");
                }
                if(InHomeUtils.isNotNull(splOffersMTM) && splOffersMTM.length > 0 && splOffersMTM.indexOf("Grubhub") > -1) {
                    splOffersMTM = splOffersMTM.replace(", Fios Grubhub Reward","");          
                }
             }
            else{
                splOffer2YRWithGrubhub = true;
                splOfferMTMWithGrubhub = true;
            }
        }
        }
        contractSelection = <div data-reveal-content="zContractAndOffer" aria-hidden="false" className={this.props.buildProduct.contract.isAccordionOpen ? 'row accordion_blocks-content m_post-offer margin-vert-large border-left border-right border-bottom bg-white-active contract-accordion-open' : 'row accordion_blocks-content m_post-offer margin-vert-large border-left border-right border-bottom bg-white-active contract-accordion-close'}>
            <div className="row padding-all-zero margin-all-zero">
                <div className="columns padding-all-zero">
                    <div className="w_accordion">
                        <div className="accordion_blocks padding-top-zero">
                            <div className="row accordion_blocks-content" data-reveal-content="zInternetOptions" style={{ transition: 'opacity 300ms' }} hidden="">
                                <div className="columns">
                                    <div className="columns tiny-padding-vert-zero tiny-padding-bottom-small small-padding-all-micro medium-padding-all-small relative accordionChild">
                                        {/* <img src={contractImage} alt="DVR and remote" className={accordionImg ? "accordion-background_images show-for-large-only" : "hide"} /> */}
                                        <div className="accordionTile">
                                            <div className={this.props.buildProduct.contract.isAccordionOpenRequired ? (this.props.buildProduct.contract.contractType === ContractConstants.twoYear ? "w_contract-blocks choice-large selected" : "w_contract-blocks") : "hide"} data-contract-term="2YRSPL" mincount="0" offers="7210#32369,36574,36431,32272,7213,7214,7220,32588," contract="2YR" role="tab"
                                                aria-selected={this.props.buildProduct.contract.isAccordionOpenRequired && (this.props.buildProduct.contract.contractType === ContractConstants.twoYear)} grouprank="2" isprimary="Y"
                                                onKeyDown={(e) => this.handleKeyDown(e, ContractConstants.twoYear)} onClick={() => { this.updateContract(ContractConstants.twoYear) }}>
                                                <div className="contract-blocks-choices m_tall-block" contract="2YR" data-contract-selection="" tabIndex={this.props.buildProduct.contract.isAccordionDisabled ? "-1" : "0"}>
                                                    <div className="inline-block vert-top text-left left p-100">
                                                        <div className="tile-head-height-contract">
                                                            <div id="Name" className="text-black text-heading line-height-tiny bold padding-top-tiny padding-bottom-micro" data-type="">2 - year agreement</div>
                                                        </div>
                                                        <div className="accordion_border"></div>                                                      
                                                        {/* <div id="SpecialTextwithHr" className={(this.props.buildProduct.contract.contractType==='2YR') || offerInCart !== null || splOffers2YR !== '' ? "padding-top-tiny" : "hide"}> */}
                                                        <div id="SpecialTextwithHr" className="hide">  {/*Fix for IR ITT-643988 */}
                                                            {visaOfferImg2YR}
                                                            <div className="contract_promo_header_accordion text text-normal normal-weight line-height-tiny margin-horiz-tiny padding-bottom-micro">{ReactHtmlParser(this.props.buildProduct.contract.contractType==='2YR' && offerContract ==='2YR' && offerInCart !== null && !splOffer2YRWithGrubhub ? offerInCart :  splOffers2YR !== '' ?  splOffers2YR : '')} </div>
                                                            {/* <div className="contract_promo_header_accordion text text-normal normal-weight line-height-tiny margin-horiz-tiny padding-bottom-micro">{splOffers2YR}</div> */}
                                                        </div>
                                                        {/* <div className={this.props.buildProduct.isGPONIONTEligible ? "padding-top-tiny" : "hide"}>
                                                            {ionteligible300}
                                                        </div> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={this.props.buildProduct.contract.contractType === ContractConstants.monthToMonth ? "w_contract-blocks selected" : "w_contract-blocks"} data-contract-term="MTM" mincount="0" grouprank="52" isprimary="Y" role="tab"
                                                aria-selected={this.props.buildProduct.contract.contractType === ContractConstants.monthToMonth}
                                                onKeyDown={(e) => this.handleKeyDown(e,ContractConstants.monthToMonth)} 
                                                onClick={() => { this.updateContract(ContractConstants.monthToMonth) }}>
                                                <div className="contract-blocks-choices choice-small m_tall-block" contract="M2M" data-contract-selection="" tabIndex={this.props.buildProduct.contract.isAccordionDisabled ? "-1" : "0"}>
                                                    <div className="inline-block vert-top text-left left p-100">
                                                        <div className="tile-head-height-contract">
                                                            <div id="Name" className="text-black text-heading line-height-tiny bold padding-top-tiny padding-bottom-micro" data-type="">No annual contract</div>
                                                        </div>
                                                        <div className="accordion_border"></div>
                                                        {/* <div id="SpecialTextwithHr" className={(this.props.buildProduct.contract.contractType==='MTM') || offerInCart !== null || splOffersMTM !== '' ? "padding-top-tiny" : "hide"}> */}
                                                        <div id="SpecialTextwithHr" className="hide">  {/*Fix for IR ITT-643988 */}
                                                            {visaOfferImgMTM}
                                                            <div className="contract_promo_header_accordion text text-normal normal-weight line-height-tiny margin-horiz-tiny padding-bottom-micro">{ReactHtmlParser(this.props.buildProduct.contract.contractType==='MTM' && offerContract === 'MTM' && offerInCart !== null && !splOfferMTMWithGrubhub ? offerInCart : splOffersMTM !== '' ? splOffersMTM : '')} </div>
                                                    {/* <div className="contract_promo_header_accordion text text-normal normal-weight line-height-tiny margin-horiz-tiny padding-bottom-micro">{splOffersMTM}</div> */}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div data-open-modal="SampleModal" className="text-normal text-right padding-left-small padding-right-small margin-top-zero padding-top-zero bg-grey-5 bold" aria-label="Opens a Modal" aria-haspopup="true">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        return (
            <React.Fragment>
                 {this.props.isHoaFlow ? '' : 
                <div className="row tiny-margin-top-none padding-all-zero active bdr-b-black" ref={(el) => this.contractAccordionRef = el}>
                    <div className="columns padding-all-zero">
                        <div className="w_accordion" id="contractAccordionBlock">
                            <div className={((this.props.buildProduct.contract.isAccordionDisabled)||(this.props.flowType==="SUPP")|| this.props.accordianDisabled ) ? "accordion_blocks disabled" : !this.props.buildProduct.contract.isAccordionOpenRequired ? "accordion_blocks disabled contract" : "accordion_blocks"}>
                                <AccordionTitle locationId={LocationIds.contractText} isHidePromo='false' title={accordionTitle} inputelementRef={this.props.inputRef}
                                    name="toggle_contract_accor" isAccordionOpenRequired={this.props.buildProduct.contract.isAccordionOpenRequired} isAccordionOpen={this.props.buildProduct.contract.isAccordionOpen}
                                    isDoflow={this.props.lqState.doFlowDetails.isDoFlow} isAccordionDisabled={isAccordionDisabled}></AccordionTitle>
                                <div className="showPad">
                                    {contractSelection}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
    }
            </React.Fragment>
        );
    }

};


export default contractAccordion;